export default "__VITE_ASSET__613974dc__"